import { client } from '../../../../Apollo';
import { GetOrders } from '../query/GetOrders';

const getOrders = (data) => new Promise((resolve, reject) => {
  client
    .query({
      query: GetOrders,
      fetchPolicy: 'network-only',
      variables: data,
    })
    .then((r) => {
      resolve(r.data.ReparafoneGetOrders);
    })
    .catch((e) => {
      console.log(e.message, 'erro ao buscar');
      reject(e.message);
    });
});

export default getOrders;
